import { maxBarsForLabels } from '.';

const minStackHeightForLabel = 20;

export function BarStackLabel({
  value,
  x,
  y,
  width,
  height,
  totalBarCount
}: {
  value: number;
  x: number;
  y: number;
  width: number;
  height: number;
  totalBarCount: number;
}) {
  if (value === 0 || totalBarCount > maxBarsForLabels || height < minStackHeightForLabel) {
    return null;
  }

  return (
    <text x={x + width / 2} y={y + height / 2} textAnchor="middle" fill="#fff" fontSize={10}>
      <tspan>{value}</tspan>
    </text>
  );
}
